import React from 'react';
import './FeaturesSection.css'; // Si quieres agregar estilos personalizados

const FeaturesSection = () => {
  return (
    <section className="features-section py-5">
      <div className="container">
        <div className="row text-center">
          <div className="col-md-4 col-lg-2">
            <div className="icon mb-3">
              <i className="fas fa-globe fa-3x"></i>
            </div>
            <h5>Aprende inglés para tu futuro</h5>
            <p>Amplía tus oportunidades con un mejor manejo del inglés.</p>
          </div>

          <div className="col-md-4 col-lg-2">
            <div className="icon mb-3">
              <i className="fas fa-microphone fa-3x"></i>
            </div>
            <h5>Mejora tu pronunciación</h5>
            <p>Aprende a hablar con claridad y confianza, sin importar tu nivel actual de inglés.</p>
          </div>

          <div className="col-md-4 col-lg-2">
            <div className="icon mb-3">
              <i className="fas fa-graduation-cap fa-3x"></i>
            </div>
            <h5>Preparación para exámenes</h5>
            <p>Te ayudamos a prepararte para tus exámenes internacionales.</p>
          </div>

          <div className="col-md-4 col-lg-2">
            <div className="icon mb-3">
              <i className="fas fa-briefcase fa-3x"></i>
            </div>
            <h5>Inglés para profesionales</h5>
            <p>Clases enfocadas en inglés para el entorno laboral.</p>
          </div>

          <div className="col-md-4 col-lg-2">
            <div className="icon mb-3">
              <i className="fas fa-book fa-3x"></i>
            </div>
            <h5>Clases interactivas y divertidas</h5>
            <p>Con métodos interactivos y prácticos, aprende de forma divertida.</p>
          </div>

          <div className="col-md-4 col-lg-2">
            <div className="icon mb-3">
              <i className="fas fa-chart-line fa-3x"></i>
            </div>
            <h5>Clases personalizadas para tu nivel</h5>
            <p>Ya seas principiante o avanzado, nuestras clases se adaptan a tu nivel.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
